import React from 'react'

import FilterTableIconSvg from '-!svg-react-loader!../../images/icons/filter-table.svg'

import HowWorksLinkIconSvg from '-!svg-react-loader!../../images/icons/how-works.svg'
import HowMainIconOilSvg from '-!svg-react-loader!../../images/how-it-works/how-main-icon-oil.svg'
import HowMainIconHardrockSvg from '-!svg-react-loader!../../images/how-it-works/how-main-icon-hardrock.svg'
import HowMainIconWindSvg from '-!svg-react-loader!../../images/how-it-works/how-main-icon-wind.svg'
import HowMainIconCoalSvg from '-!svg-react-loader!../../images/how-it-works/how-main-icon-coal.svg'
import HowItWorksRibbonGraphicSvg from '-!svg-react-loader!../../images/how-it-works/how-it-works-ribbon-graphic.svg'
import AmlUnappropGrowthSvg from '-!svg-react-loader!../../images/how-it-works/AML_unapprop-growth.svg'

import OnrrLogoSvg from '-!svg-react-loader!../../images/logos/ONRR-mark.svg'
import NrrdLogoSvg from '-!svg-react-loader!../../images/logos/NRRD-logo.svg'

import Rig404Svg from '-!svg-react-loader!../../images/svg/rig-404.svg'
import LineWithArrowSvg from '-!svg-react-loader!../../images/svg/line-with-arrow.svg'

import IconOilSvg from '-!svg-react-loader!../../images/icons/icon-oil.svg'
import IconCoalSvg from '-!svg-react-loader!../../images/icons/icon-coal.svg'
import IconHardrockSvg from '-!svg-react-loader!../../images/icons/icon-hardrock.svg'
import IconGeothermalSvg from '-!svg-react-loader!../../images/icons/icon-geothermal.svg'
import IconRenewablesSvg from '-!svg-react-loader!../../images/icons/icon-renewables.svg'
import IconArchiveSvg from '-!svg-react-loader!../../images/icons/icon-archive.svg'
import IconDownloadBaseSvg from '-!svg-react-loader!../../images/icons/icon-download-base.svg'
import IconDownloadXlsSvg from '-!svg-react-loader!../../images/icons/icon-download-xls.svg'
import IconDownloadCsvSvg from '-!svg-react-loader!../../images/icons/icon-download-csv.svg'
import IconDownloadDataSvg from '-!svg-react-loader!../../images/icons/icon-download-data.svg'
import IconQuestionCircleSvg from '-!svg-react-loader!../../images/icons/icon-question-circle.svg'
import IconUsMapSvg from '-!svg-react-loader!../../images/icons/icon-us-map.svg'
import IconExploreDataSvg from '-!svg-react-loader!../../images/icons/explore-data.svg'

// Maps US States
import MapStateallSvg from '-!svg-react-loader!../../images/maps/states/all.svg'
import MapStateAKSvg from '-!svg-react-loader!../../images/maps/states/AK.svg'
import MapStateALSvg from '-!svg-react-loader!../../images/maps/states/AL.svg'
import MapStateARSvg from '-!svg-react-loader!../../images/maps/states/AR.svg'
import MapStateAZSvg from '-!svg-react-loader!../../images/maps/states/AZ.svg'
import MapStateCASvg from '-!svg-react-loader!../../images/maps/states/CA.svg'
import MapStateCOSvg from '-!svg-react-loader!../../images/maps/states/CO.svg'
import MapStateCTSvg from '-!svg-react-loader!../../images/maps/states/CT.svg'
import MapStateDCSvg from '-!svg-react-loader!../../images/maps/states/DC.svg'
import MapStateDESvg from '-!svg-react-loader!../../images/maps/states/DE.svg'
import MapStateFLSvg from '-!svg-react-loader!../../images/maps/states/FL.svg'
import MapStateGASvg from '-!svg-react-loader!../../images/maps/states/GA.svg'
import MapStateHISvg from '-!svg-react-loader!../../images/maps/states/HI.svg'
import MapStateIASvg from '-!svg-react-loader!../../images/maps/states/IA.svg'
import MapStateIDSvg from '-!svg-react-loader!../../images/maps/states/ID.svg'
import MapStateILSvg from '-!svg-react-loader!../../images/maps/states/IL.svg'
import MapStateINSvg from '-!svg-react-loader!../../images/maps/states/IN.svg'
import MapStateKSSvg from '-!svg-react-loader!../../images/maps/states/KS.svg'
import MapStateKYSvg from '-!svg-react-loader!../../images/maps/states/KY.svg'
import MapStateLASvg from '-!svg-react-loader!../../images/maps/states/LA.svg'
import MapStateMASvg from '-!svg-react-loader!../../images/maps/states/MA.svg'
import MapStateMDSvg from '-!svg-react-loader!../../images/maps/states/MD.svg'
import MapStateMESvg from '-!svg-react-loader!../../images/maps/states/ME.svg'
import MapStateMISvg from '-!svg-react-loader!../../images/maps/states/MI.svg'
import MapStateMNSvg from '-!svg-react-loader!../../images/maps/states/MN.svg'
import MapStateMOSvg from '-!svg-react-loader!../../images/maps/states/MO.svg'
import MapStateMSSvg from '-!svg-react-loader!../../images/maps/states/MS.svg'
import MapStateMTSvg from '-!svg-react-loader!../../images/maps/states/MT.svg'
import MapStateNCSvg from '-!svg-react-loader!../../images/maps/states/NC.svg'
import MapStateNDSvg from '-!svg-react-loader!../../images/maps/states/ND.svg'
import MapStateNESvg from '-!svg-react-loader!../../images/maps/states/NE.svg'
import MapStateNHSvg from '-!svg-react-loader!../../images/maps/states/NH.svg'
import MapStateNJSvg from '-!svg-react-loader!../../images/maps/states/NJ.svg'
import MapStateNMSvg from '-!svg-react-loader!../../images/maps/states/NM.svg'
import MapStateNVSvg from '-!svg-react-loader!../../images/maps/states/NV.svg'
import MapStateNYSvg from '-!svg-react-loader!../../images/maps/states/NY.svg'
import MapStateOHSvg from '-!svg-react-loader!../../images/maps/states/OH.svg'
import MapStateOKSvg from '-!svg-react-loader!../../images/maps/states/OK.svg'
import MapStateORSvg from '-!svg-react-loader!../../images/maps/states/OR.svg'
import MapStatePASvg from '-!svg-react-loader!../../images/maps/states/PA.svg'
import MapStateRISvg from '-!svg-react-loader!../../images/maps/states/RI.svg'
import MapStateSCSvg from '-!svg-react-loader!../../images/maps/states/SC.svg'
import MapStateSDSvg from '-!svg-react-loader!../../images/maps/states/SD.svg'
import MapStateTNSvg from '-!svg-react-loader!../../images/maps/states/TN.svg'
import MapStateTXSvg from '-!svg-react-loader!../../images/maps/states/TX.svg'
import MapStateUTSvg from '-!svg-react-loader!../../images/maps/states/UT.svg'
import MapStateVASvg from '-!svg-react-loader!../../images/maps/states/VA.svg'
import MapStateVTSvg from '-!svg-react-loader!../../images/maps/states/VT.svg'
import MapStateWASvg from '-!svg-react-loader!../../images/maps/states/WA.svg'
import MapStateWISvg from '-!svg-react-loader!../../images/maps/states/WI.svg'
import MapStateWVSvg from '-!svg-react-loader!../../images/maps/states/WV.svg'
import MapStateWYSvg from '-!svg-react-loader!../../images/maps/states/WY.svg'

import WarningIcon from '@material-ui/icons/Warning'

export const WarningIconImg = props => <WarningIcon {...props} />

export const FilterTableIconImg = props => <FilterTableIconSvg {...props} style={{ fill: 'currentColor' }} aria-hidden='true' />

export const HowWorksLinkIconImg = props => <HowWorksLinkIconSvg style={{ verticalAlign: 'middle', fill: 'currentColor' }} {...props} aria-hidden='true' />
export const HowMainIconOilImg = props => <HowMainIconOilSvg {...props} />
export const HowMainIconHardrockImg = props => <HowMainIconHardrockSvg {...props} />
export const HowMainIconWindImg = props => <HowMainIconWindSvg {...props} />
export const HowMainIconCoalImg = props => <HowMainIconCoalSvg {...props} />
export const HowItWorksRibbonGraphicImg = props => <HowItWorksRibbonGraphicSvg {...props} />
export const AmlUnappropGrowthImg = ({ alt, ...props }) => <AmlUnappropGrowthSvg {...props} alt={alt || 'Chart shows the growth of the AML fund\'s unappropriated ' +
  'balance from 1989 to 2017. It grew from around $500 million to nearly $2.5 billion dollars in 2015, before falling slightly to $2.38 billion in 2017.'}/>

export const OnrrLogoImg = ({ alt, ...props }) => <OnrrLogoSvg {...props} alt={alt || 'A six-color logo with the ONRR acronym in large text in the top left corner, ' +
  'and in smaller text below it, "Office of Natural Resources Revenue". Behind the text is a partial sun with beams in a light blue and slightly darker blue color. ' +
  'Dark blue and dark purple mountains are located in the middle of the logo with white icons of a windmill, an oil pumpjack, and trees. A white offshore oil rig in ' +
  'the bottom-right corner is separated by the mountains by a two-tone green arc.'}/>
export const NrrdLogoImg = props => <NrrdLogoSvg {...props} />

export const Rig404Img = props => <Rig404Svg {...props} />
export const LineWithArrowImg = props => <LineWithArrowSvg {...props} />

export const IconOilImg = props => <IconOilSvg {...props} />
export const IconCoalImg = props => <IconCoalSvg {...props} />
export const IconHardrockImg = props => <IconHardrockSvg {...props} />
export const IconGeothermalImg = props => <IconGeothermalSvg {...props} />
export const IconRenewablesImg = props => <IconRenewablesSvg {...props} />
export const IconArchiveImg = props => <IconArchiveSvg style={{ verticalAlign: 'middle' }} {...props}/>
export const IconDownloadBaseImg = props => <IconDownloadBaseSvg style={{ verticalAlign: 'middle', fill: 'currentColor' }} {...props} aria-hidden='true'/>
export const IconDownloadXlsImg = props => <IconDownloadXlsSvg style={{ verticalAlign: 'middle', fill: 'currentColor' }} {...props} aria-hidden='true'/>
export const IconDownloadCsvImg = props => <IconDownloadCsvSvg style={{ verticalAlign: 'middle', fill: 'currentColor' }} {...props} aria-hidden='true'/>
export const IconDownloadDataImg = props => <IconDownloadDataSvg style={{ verticalAlign: 'middle', fill: 'currentColor' }} {...props} aria-hidden='true'/>
export const IconQuestionCircleImg = props => <IconQuestionCircleSvg style={{ width: '16px', height: '16px', marginLeft: '1.6px', fill: 'currentColor' }} {...props}/>
export const IconUsMapImg = props => <IconUsMapSvg {...props} style={{ position: 'relative', top: 10, fill: 'currentColor' }} />
export const IconExploreDataImg = props => <IconExploreDataSvg style={{ fill: 'currentColor' }} {...props} />

export const MapStateallImg = props => <MapStateallSvg {...props} />
export const MapStateAKImg = props => <MapStateAKSvg {...props} />
export const MapStateALImg = props => <MapStateALSvg {...props} />
export const MapStateARImg = props => <MapStateARSvg {...props} />
export const MapStateAZImg = props => <MapStateAZSvg {...props} />
export const MapStateCAImg = props => <MapStateCASvg {...props} />
export const MapStateCOImg = props => <MapStateCOSvg {...props} />
export const MapStateCTImg = props => <MapStateCTSvg {...props} />
export const MapStateDCImg = props => <MapStateDCSvg {...props} />
export const MapStateDEImg = props => <MapStateDESvg {...props} />
export const MapStateFLImg = props => <MapStateFLSvg {...props} />
export const MapStateGAImg = props => <MapStateGASvg {...props} />
export const MapStateHIImg = props => <MapStateHISvg {...props} />
export const MapStateIAImg = props => <MapStateIASvg {...props} />
export const MapStateIDImg = props => <MapStateIDSvg {...props} />
export const MapStateILImg = props => <MapStateILSvg {...props} />
export const MapStateINImg = props => <MapStateINSvg {...props} />
export const MapStateKSImg = props => <MapStateKSSvg {...props} />
export const MapStateKYImg = props => <MapStateKYSvg {...props} />
export const MapStateLAImg = props => <MapStateLASvg {...props} />
export const MapStateMAImg = props => <MapStateMASvg {...props} />
export const MapStateMDImg = props => <MapStateMDSvg {...props} />
export const MapStateMEImg = props => <MapStateMESvg {...props} />
export const MapStateMIImg = props => <MapStateMISvg {...props} />
export const MapStateMNImg = props => <MapStateMNSvg {...props} />
export const MapStateMOImg = props => <MapStateMOSvg {...props} />
export const MapStateMSImg = props => <MapStateMSSvg {...props} />
export const MapStateMTImg = props => <MapStateMTSvg {...props} />
export const MapStateNCImg = props => <MapStateNCSvg {...props} />
export const MapStateNDImg = props => <MapStateNDSvg {...props} />
export const MapStateNEImg = props => <MapStateNESvg {...props} />
export const MapStateNHImg = props => <MapStateNHSvg {...props} />
export const MapStateNJImg = props => <MapStateNJSvg {...props} />
export const MapStateNMImg = props => <MapStateNMSvg {...props} />
export const MapStateNVImg = props => <MapStateNVSvg {...props} />
export const MapStateNYImg = props => <MapStateNYSvg {...props} />
export const MapStateOHImg = props => <MapStateOHSvg {...props} />
export const MapStateOKImg = props => <MapStateOKSvg {...props} />
export const MapStateORImg = props => <MapStateORSvg {...props} />
export const MapStatePAImg = props => <MapStatePASvg {...props} />
export const MapStateRIImg = props => <MapStateRISvg {...props} />
export const MapStateSCImg = props => <MapStateSCSvg {...props} />
export const MapStateSDImg = props => <MapStateSDSvg {...props} />
export const MapStateTNImg = props => <MapStateTNSvg {...props} />
export const MapStateTXImg = props => <MapStateTXSvg {...props} />
export const MapStateUTImg = props => <MapStateUTSvg {...props} />
export const MapStateVAImg = props => <MapStateVASvg {...props} />
export const MapStateVTImg = props => <MapStateVTSvg {...props} />
export const MapStateWAImg = props => <MapStateWASvg {...props} />
export const MapStateWIImg = props => <MapStateWISvg {...props} />
export const MapStateWVImg = props => <MapStateWVSvg {...props} />
export const MapStateWYImg = props => <MapStateWYSvg {...props} />
